var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLnerHorizontalLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 48,
    viewBox: "0 0 375 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 42.6875H111.217C117.732 42.6875 126.33 38.5819 130.423 33.5196L146.075 14.1688C150.169 9.10653 158.771 5.00095 165.281 5.00095H375",
    stroke: "#E17F73",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.3 29.6016V6.76676",
    stroke: "#E17F73",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnerHorizontalLine);
export default __webpack_public_path__ + "static/media/lner_horizontal_line.fe1ba71931f2c2d1647646cc3deed6c2.svg";
export { ForwardRef as ReactComponent };